var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    clipPath: "url(#clip0_1344_45319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C9.16 13 10.5 11.66 10.5 10C10.5 8.34 9.16 7 7.5 7C5.84 7 4.5 8.34 4.5 10C4.5 11.66 5.84 13 7.5 13ZM19.5 7H13.5C12.4 7 11.5 7.9 11.5 9V14H3.5V6C3.5 5.45 3.05 5 2.5 5C1.95 5 1.5 5.45 1.5 6V19C1.5 19.55 1.95 20 2.5 20C3.05 20 3.5 19.55 3.5 19V17H21.5V19C21.5 19.55 21.95 20 22.5 20C23.05 20 23.5 19.55 23.5 19V11C23.5 8.79 21.71 7 19.5 7Z",
    fill: "#525A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C9.16 13 10.5 11.66 10.5 10C10.5 8.34 9.16 7 7.5 7C5.84 7 4.5 8.34 4.5 10C4.5 11.66 5.84 13 7.5 13ZM19.5 7H13.5C12.4 7 11.5 7.9 11.5 9V14H3.5V6C3.5 5.45 3.05 5 2.5 5C1.95 5 1.5 5.45 1.5 6V19C1.5 19.55 1.95 20 2.5 20C3.05 20 3.5 19.55 3.5 19V17H21.5V19C21.5 19.55 21.95 20 22.5 20C23.05 20 23.5 19.55 23.5 19V11C23.5 8.79 21.71 7 19.5 7Z",
    fill: "black",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1344_45319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.992ca9c309729fb5743a1ed7108b5849.svg";
export { ForwardRef as ReactComponent };